import { Button } from 'antd';
import Link from 'next/link';
import React from 'react';

const Custom404 = () => {
  return (
    <div className='grid min-h-full place-items-center  px-6 py-32 sm:py-48 lg:px-8'>
      <div className='text-center'>
        <p className='text-2xl font-semibold text-primary'>404</p>
        <h1 className='mt-4 text-3xl font-bold tracking-tight text-fadedWhite sm:text-5xl'>
          Page not found
        </h1>
        <p className='mt-6 text-base leading-7 text-gray-100'>
          Sorry, we couldn’t find the page you’re looking for.
        </p>
        <div className='mt-10 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6'>
          <Link href='/'>
            <span className='rounded-md bg-primary px-3.5 py-2.5 text-sm font-semibold cursor-pointer text-white shadow-sm hover:bg-darkPrimary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'>
              Go back home
            </span>
          </Link>

          <Button
            onClick={() =>
              window?.open(
                'https://support.zebralearn.com/support/home',
                '_blank'
              )
            }
            type='text'
            size='large'
            className='flex gap-x-2 font-medium '
          >
            <span className='text-fadedWhite hover:text-gray-100'>
              Contact Support <span> &rarr;</span>
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Custom404;
